export type DatafordelerAddress = {
  fullAddress: string;
  data: {
    doorNumber: string;
    floorNumber: string;
    buildingNumber: string;
    postalCode: string;
    cityName: string;
    streetName: string;
  };
};

export enum DatafordelerDataType {
  vejnavn,
  ad
}

export type DatafordelerAutocompleteResponse = {
  status: string;
  beskrivelse: string;
  fund: Array<DatafordelerAutocomplete>;
};

export type DatafordelerAutocomplete = {
  type: DatafordelerDataType;
  titel: string;
  id?: string;
};

export type DarAddressFlexible = {
  adressebetegnelse: string;
  doerbetegnelse: string;
  etagebetegnelse: string;
  adresseHarHusnummer: {
    husnummertekst: string;
    husnummerHoererTilIPostnummer: {
      navn: string;
      postnr: string;
    };
    husnummerHoererTilNavngivenVej: {
      vejnavn: string;
    };
  };
};

export type DarResponse = {
  data: {
    DAR_Adresse: {
      nodes: Array<DarAddressFlexible>;
    };
  };
};

export const DarAddressFields = {
  adressebetegnelse: 'adressebetegnelse',
  doerbetegnelse: 'doerbetegnelse',
  etagebetegnelse: 'etagebetegnelse'
};

export const DarHusnummerFields = {
  husnummertekst: 'husnummertekst'
};

export const DarPostnummerFields = {
  navn: 'navn',
  postnr: 'string'
};

export const DarNavngivenVejFields = {
  vejnavn: 'vejnavn'
};
